<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal,
  BButton,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BTable,
  BCard,
  BCardTitle,
  BCardHeader,
  BOverlay,
  BSpinner,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { avatarText } from '@core/utils/filter';
import axios from '@/libs/axios';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BCardHeader,
    BCardTitle,
    BCard,
    BTable,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    BSpinner,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    todosPerfils: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      perfilsUsuario: [],
      perfilsProcessados: [],
      isLoading: false,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.perfilsProcessados.length > 0 ? this.perfilsProcessados : this.todosPerfils;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.carregarPermissoesUsuario();
  },
  watch: {
    'userData.usuarioid': {
      handler(novoId) {
        if (novoId) {
          this.carregarPermissoesUsuario();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async carregarPermissoesUsuario() {
      if (!this.userData || !this.userData.usuarioid) {
        console.log('ID do usuário não disponível');
        return;
      }

      this.isLoading = true;
      try {
        const response = await axios.get(`/usuarioPerfil/findPermissoes/${this.userData.usuarioid}`);

        if (response.data && response.data.data) {
          this.perfilsUsuario = response.data.data;
          this.processarPerfils();
        }
      } catch (error) {
        console.error('Erro ao carregar permissões do usuário:', error);
      } finally {
        this.isLoading = false;
      }
    },

    processarPerfils() {
      this.perfilsProcessados = this.todosPerfils.map((perfil) => {
        const temPerfil = this.perfilsUsuario.some(
          (p) => String(p.id_perfil_acesso) === String(perfil.id),
        );

        return {
          ...perfil,
          status: temPerfil,
        };
      });
    },

    async onSubmit(userData, todosPerfils) {
      this.isLoading = true;
      try {
        const perfilsParaEnviar = this.perfilsProcessados || todosPerfils;

        const response = await axios.put(
          `/usuarios/updatePerfilsUsuario/${userData.usuarioid}`,
          perfilsParaEnviar,
        );

        console.log(response);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Perfis de acesso atualizados',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        // this.$bvModal.hide('modal-att-usuario')
      } catch (error) {
        console.error('Erro ao atualizar perfis:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Falha ao atualizar perfis de acesso',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  setup() {
    const tabelaPerfils = [
      { key: 'perfil_acesso_nome', label: 'Nome', sortable: true },
      { key: 'status', label: 'Status' },
    ];

    return {
      avatarText,
      tabelaPerfils,
    };
  },
};
</script>

<template>
  <b-overlay :show="isLoading" rounded="sm">
    <validation-observer ref="refFormData">
      <div>
        <feather-icon
            icon="LockIcon"
            size="18"
        />
        <span class="align-middle ml-50">Lista de permissões</span>

        <b-table
          striped
          responsive
          class="mb-0"
          :items="perfilsProcessados.length > 0 ? perfilsProcessados : todosPerfils"
          :fields="tabelaPerfils"
        >
          <template #cell(status)="data">
            <div>
              <b-form-checkbox
                  v-model="data.item.status"
                  class="custom-control-success"
                  name="check-button"
                  switch
              />
            </div>
          </template>
        </b-table>
      </div>

      <div class="mt-2">
        <b-button
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :disabled="isLoading"
            @click="onSubmit(userData, perfilsProcessados.length > 0 ? perfilsProcessados : todosPerfils)"
        >
          <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
          Salvar Alterações
        </b-button>
      </div>
    </validation-observer>
  </b-overlay>
</template>
